import { render } from "./ManagementApproachmanagement.vue?vue&type=template&id=1b468609&scoped=true"
import script from "./ManagementApproachmanagement.vue?vue&type=script&lang=js"
export * from "./ManagementApproachmanagement.vue?vue&type=script&lang=js"

import "./ManagementApproachmanagement.vue?vue&type=style&index=0&id=1b468609&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b468609"]])

export default __exports__